import React from "react";
import { SendIcon } from "@/components/common/icons/SendIcon";
import TextareaAutosize from "react-textarea-autosize";
import { Button } from "@/components/common/Button";
import { classNames } from "@/utils/utils";
import { Field, Form, Formik } from "formik";
import { object, string } from "yup";

import styles from "./TextInputPanel.module.css";

type Props = {
  className?: string;
  disabled?: boolean;
  onNewMessage: (value: string) => void;
  children?: React.ReactNode;
};

export const TextInputPanel: React.FC<Props> = ({
  onNewMessage,
  className,
  disabled,
  children,
}) => {
  return (
    <div className={classNames(styles.wrap, className)}>
      <Formik
        validationSchema={object().shape({
          message: string().required().min(1).max(255),
        })}
        initialValues={{ message: "" }}
        onSubmit={(values, { resetForm }) => {
          onNewMessage(values.message);
          resetForm();
        }}
      >
        {({ isValid, submitForm }) => (
          <Form className={styles.inputWrap}>
            <Field name="message">
              {({ field }: any) => (
                <TextareaAutosize
                  className="chatInputField"
                  placeholder="Écrivez votre texte ici..."
                  maxLength={150}
                  autoComplete="off"
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      if (isValid) {
                        submitForm();
                      }
                    }
                  }}
                  {...field}
                />
              )}
            </Field>
            <Button
              type="submit"
              variant="primary"
              disabled={disabled || !isValid}
              className={styles.submit}
            >
              <SendIcon className={styles.sendIcon} />
            </Button>
          </Form>
        )}
      </Formik>
      {children}
    </div>
  );
};
